import React from 'react'

import PropTypes from 'prop-types'

import Breadcrumb from 'components/Breadcrumb'
import Loading from 'components/Loading'

import PageTitle from './PageTitle'
import Item from './Item'

const List = props => (
  <div className="page-content">
    {props.isLoading && (<Loading />)}
    <Breadcrumb data={props} />
    <PageTitle />
    <div className="row">
      <div className="col-md-12">
        <div className="portlet light portlet-fit">
          <div className="portlet-title">
            <div className="caption">
              <span className="caption-subject sbold uppercase">Creators list</span>
            </div>
          </div>
          <div className="portlet-body">
            <div className="table-scrollable table-scrollable-borderless">
              <table className="table table-hover table-light">
                <thead>
                  <tr className="uppercase">
                    <th> # </th>
                    <th> Created At </th>
                    <th> Name </th>
                    <th> Profile ID </th>
                    <th> Country </th>
                    <th> City </th>
                    <th> Logo </th>
                    <th className="table-actions"> Actions </th>
                  </tr>
                </thead>
                <tbody>
                  { props.creators.rows &&
                      props.creators.rows.length > 0 &&
                      (props
                      .creators
                      .rows
                      .map((row, key) => (
                        <Item indexKey={key} key={row.id} row={row} />
                      ))
                    )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

List.defaultProps = {
  creators: {
    rows: [],
  },
  isLoading: false,
}

List.propTypes = {
  creators: PropTypes.shape({
    rows: PropTypes.array.isRequired,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
}
export default List
